import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useInView } from "react-intersection-observer";

interface FadeInOnScrollProps {
  children: ReactNode;
  className?: string;
  /** Delay in milliseconds before animation starts */
  delay?: number;
}

/**
 * Fade-in animation triggered when element enters viewport
 * Uses intersection observer for performance
 */
export function FadeInOnScroll({
  children,
  className,
  delay = 0,
}: FadeInOnScrollProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={cn(
        "transition-all duration-700 ease-out",
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
        className
      )}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
